import {
  LiveUpdateEvent,
  SUBTASK_ATTACHMENT_MODULE,
  SUBTASK_MODULE,
  TASK_ATTACHMENT_MODULE,
  TASK_CLIENT_FEEDBACK_MODULE,
  TASK_COMMENT_MODULE,
  TASK_MODULE,
} from "../../../live-updates";
import {
  ADDED_ACTION,
  ARCHIVED_ACTION,
  CREATED_ACTION,
  DELETED_ACTION,
  MOVED_ACTION,
  REARRANGED_ACTION,
  RENAMED_ACTION,
  RESTORED_ACTION,
  SubtaskAttachmentLiveUpdateCreatedEvent,
  SubtaskAttachmentLiveUpdateDeletedEvent,
  SubtaskAttachmentLiveUpdateEvent,
  SubtaskAttachmentLiveUpdateRenamedEvent,
  SubtaskLiveUpdateCreatedEvent,
  SubtaskLiveUpdateDeletedEvent,
  SubtaskLiveUpdateEvent,
  SubtaskLiveUpdateMovedEvent,
  SubtaskLiveUpdateRearrangedEvent,
  SubtaskLiveUpdateUpdatedEvent,
  TaskAttachmentLiveUpdateCreatedEvent,
  TaskAttachmentLiveUpdateDeletedEvent,
  TaskAttachmentLiveUpdateEvent,
  TaskAttachmentLiveUpdateRenamedEvent,
  TaskClientFeedbackLiveUpdateCreatedEvent,
  TaskClientFeedbackLiveUpdateDeletedEvent,
  TaskClientFeedbackLiveUpdateEvent,
  TaskClientFeedbackLiveUpdateUpdatedEvent,
  TaskCommentLiveUpdateCreatedEvent,
  TaskCommentLiveUpdateDeletedEvent,
  TaskCommentLiveUpdateEvent,
  TaskCommentLiveUpdateUpdatedEvent,
  TaskLiveUpdateArchivedEvent,
  TaskLiveUpdateCreatedEvent,
  TaskLiveUpdateDeletedEvent,
  TaskLiveUpdateEvent,
  TaskLiveUpdateRestoredEvent,
  TaskLiveUpdateUpdatedEvent,
  UPDATED_ACTION,
} from "./types";

// #region Task module type guards
export const isTaskLiveUpdateEvent = (
  event: LiveUpdateEvent
): event is TaskLiveUpdateEvent => event.module === TASK_MODULE;

export const isTaskCreatedEvent = (
  event: TaskLiveUpdateEvent
): event is TaskLiveUpdateCreatedEvent => event.action === CREATED_ACTION;

export const isTaskRestoredEvent = (
  event: TaskLiveUpdateEvent
): event is TaskLiveUpdateRestoredEvent => event.action === RESTORED_ACTION;

export const isTaskUpdatedEvent = (
  event: TaskLiveUpdateEvent
): event is TaskLiveUpdateUpdatedEvent => event.action === UPDATED_ACTION;

export const isTaskDeletedEvent = (
  event: TaskLiveUpdateEvent
): event is TaskLiveUpdateDeletedEvent => event.action === DELETED_ACTION;

export const isTaskArchivedEvent = (
  event: TaskLiveUpdateEvent
): event is TaskLiveUpdateArchivedEvent => event.action === ARCHIVED_ACTION;
// #endregion

// #region Task attachment module type guards
export const isTaskAttachmentLiveUpdateEvent = (
  event: LiveUpdateEvent
): event is TaskAttachmentLiveUpdateEvent =>
  event.module === TASK_ATTACHMENT_MODULE;

export const isTaskAttachmentCreatedEvent = (
  event: TaskAttachmentLiveUpdateEvent
): event is TaskAttachmentLiveUpdateCreatedEvent =>
  event.action === ADDED_ACTION;

export const isTaskAttachmentRenamedEvent = (
  event: TaskAttachmentLiveUpdateEvent
): event is TaskAttachmentLiveUpdateRenamedEvent =>
  event.action === RENAMED_ACTION;

export const isTaskAttachmentDeletedEvent = (
  event: TaskAttachmentLiveUpdateEvent
): event is TaskAttachmentLiveUpdateDeletedEvent =>
  event.action === DELETED_ACTION;
// #endregion

// #region Task comment module type guards
export const isTaskCommentLiveUpdateEvent = (
  event: LiveUpdateEvent
): event is TaskCommentLiveUpdateEvent => event.module === TASK_COMMENT_MODULE;

export const isTaskCommentCreatedEvent = (
  event: TaskCommentLiveUpdateEvent
): event is TaskCommentLiveUpdateCreatedEvent =>
  event.action === CREATED_ACTION;

export const isTaskCommentUpdatedEvent = (
  event: TaskCommentLiveUpdateEvent
): event is TaskCommentLiveUpdateUpdatedEvent =>
  event.action === UPDATED_ACTION;

export const isTaskCommentDeletedEvent = (
  event: TaskCommentLiveUpdateEvent
): event is TaskCommentLiveUpdateDeletedEvent =>
  event.action === DELETED_ACTION;
// #endregion

// #region Task client feedback module type guards
export const isTaskClientFeedbackLiveUpdateEvent = (
  event: LiveUpdateEvent
): event is TaskClientFeedbackLiveUpdateEvent =>
  event.module === TASK_CLIENT_FEEDBACK_MODULE;

export const isTaskClientFeedbackCreatedEvent = (
  event: TaskClientFeedbackLiveUpdateEvent
): event is TaskClientFeedbackLiveUpdateCreatedEvent =>
  event.action === CREATED_ACTION;

export const isTaskClientFeedbackUpdatedEvent = (
  event: TaskClientFeedbackLiveUpdateEvent
): event is TaskClientFeedbackLiveUpdateUpdatedEvent =>
  event.action === UPDATED_ACTION;

export const isTaskClientFeedbackDeletedEvent = (
  event: TaskClientFeedbackLiveUpdateEvent
): event is TaskClientFeedbackLiveUpdateDeletedEvent =>
  event.action === DELETED_ACTION;
// #endregion

// #region Subtask module type guards
export const isSubtaskLiveUpdateEvent = (
  event: LiveUpdateEvent
): event is SubtaskLiveUpdateEvent => event.module === SUBTASK_MODULE;

export const isSubtaskCreatedEvent = (
  event: SubtaskLiveUpdateEvent
): event is SubtaskLiveUpdateCreatedEvent => event.action === ADDED_ACTION;

export const isSubtaskUpdatedEvent = (
  event: SubtaskLiveUpdateEvent
): event is SubtaskLiveUpdateUpdatedEvent => event.action === UPDATED_ACTION;

export const isSubtaskDeletedEvent = (
  event: SubtaskLiveUpdateEvent
): event is SubtaskLiveUpdateDeletedEvent => event.action === DELETED_ACTION;

export const isSubtaskMovedEvent = (
  event: SubtaskLiveUpdateEvent
): event is SubtaskLiveUpdateMovedEvent => event.action === MOVED_ACTION;

export const isSubtaskRearrangedEvent = (
  event: SubtaskLiveUpdateEvent
): event is SubtaskLiveUpdateRearrangedEvent =>
  event.action === REARRANGED_ACTION;
// #endregion

// #region Subtask attachment module type guards
export const isSubtaskAttachmentLiveUpdateEvent = (
  event: LiveUpdateEvent
): event is SubtaskAttachmentLiveUpdateEvent =>
  event.module === SUBTASK_ATTACHMENT_MODULE;

export const isSubtaskAttachmentCreatedEvent = (
  event: SubtaskAttachmentLiveUpdateEvent
): event is SubtaskAttachmentLiveUpdateCreatedEvent =>
  event.action === ADDED_ACTION;

export const isSubtaskAttachmentRenamedEvent = (
  event: SubtaskAttachmentLiveUpdateEvent
): event is SubtaskAttachmentLiveUpdateRenamedEvent =>
  event.action === RENAMED_ACTION;

export const isSubtaskAttachmentDeletedEvent = (
  event: SubtaskAttachmentLiveUpdateEvent
): event is SubtaskAttachmentLiveUpdateDeletedEvent =>
  event.action === DELETED_ACTION;
// #endregion
